const AboutConstants = {
  // About specific
  SHOW_ABOUT: 'SR_ABOUT_SHOW',
  HIDE_ABOUT: 'SR_ABOUT_HIDE',
  GET_FAIL: 'SR_ABOUT_GET_FAIL',
  GET_SUCCESS: 'SR_ABOUT_GET_SUCCESS',
  GET_LEGAL_NOTICES_SUCCESS: 'SR_ABOUT_GET_LEGAL_NOTICES_SUCCESS',
  GET_LEGAL_NOTICES_FAIL: 'SR_ABOUT_GET_LEGAL_NOTICES_FAIL'
};

export default AboutConstants;
